<div class="app-content-container">
  <div class="flex flex-col justify-center items-center h-full">
    <!-- Logo Box -->
    <header class="login-header w-4/5 place-content-center">
      <a class="company-logo-container" target="_blank" href="https://www.lufthansagroup.com/de/home.html" rel="noopener">
        <img class="w-1/2 h-[2rem]" [src]="logoUrl" alt="Media Lounge" />
      </a>

      <sp-mobile-navigation class="toggle-button-top-right">
        <sp-footer></sp-footer>
      </sp-mobile-navigation>
    </header>

    <div class="login-main w-4/5 max-w-screen-sm place-content-center">
      <div *ngIf="!validToken && !loading" class="flex flex-col place-content-center max-w-screen-sm">
        <div class="flex flex-col justify-center h-full mb-2 confirm-email">
          <h2 class="text-center text-lg mt-8 font-bold" i18n>The link you followed is no longer valid</h2>

          <!-- Back to login page -->
          <div class="flex flex-col justify-center mt-8">
            <a class="text-center font-bold underline text-sm link-color" [routerLink]="['/login']" i18n>Back to login</a>
          </div>
        </div>
      </div>
      <div *ngIf="validToken" class="flex flex-col place-content-center max-w-screen-sm">
        <form class="w-full" [formGroup]="form" (ngSubmit)="onSubmit()">
          <div>
            <h2 class="font-bold text-3xl my-8" i18n>Reset Password</h2>
          </div>
          <!-- Password -->
          <div class="mb-4">
            <div class="w-full">
              <div class="flex flex-row place-content-between">
                <span class="field-label" i18n>New Password</span>
              </div>
              <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                <mat-icon matSuffix (click)="toggleVisibility()">{{ hide ? 'visibility_off' : 'visibility' }} </mat-icon>
                <input matInput [type]="inputType" placeholder="Password" formControlName="password" />
                <mat-error *ngIf="form.controls['password'].hasError('required')" i18n>Password is required </mat-error>
                <mat-error
                  *ngIf="
                    form.controls['password'].hasError('hasSpecialCharacters') ||
                    form.controls['password'].hasError('minlength') ||
                    form.controls['password'].hasError('hasNumber') ||
                    form.controls['password'].hasError('hasCapitalCase') ||
                    (form.controls['password'].hasError('hasSmallCase') && !form.controls['password'].hasError('required'))
                  "
                  i18n
                  >Password should have atleast 8 characters, a special character, a number, a capital letter and a small letter</mat-error
                >
              </mat-form-field>
            </div>
          </div>
          <!--Confirm Password -->
          <div class="mb-4">
            <div class="w-full">
              <div class="flex flex-row place-content-between">
                <span class="field-label" i18n>Confirm Password</span>
              </div>
              <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                <mat-icon matSuffix (click)="toggleVisibility()">{{ hide ? 'visibility_off' : 'visibility' }} </mat-icon>
                <input matInput [type]="inputType" placeholder="Confirm Password" formControlName="confirmPassword" />
                <mat-error *ngIf="form.controls['confirmPassword'].hasError('required')" i18n>Confirm Password is required</mat-error>
              </mat-form-field>
              <mat-error class="text-[13px]" *ngIf="form.hasError('notSame') && !form.controls['confirmPassword'].hasError('required')" i18n>Passwords are not same </mat-error>
            </div>
          </div>
          <!-- Button-->
          <div class="mb-4 w-full">
            <div class="flex flex-row place-content-between items-center">
              <button mat-flat-button class="flex-auto w-2/5 button-primary" [disabled]="form.invalid || showSubmitButton" type="submit" i18n>Submit</button>
            </div>
          </div>
          <!-- Spinner -->
          <div class="w-full flex flex-row justify-center items-center" *ngIf="loading">
            <mat-spinner [diameter]="30" color="warn"></mat-spinner>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="app-footer-container">
  <div class="flex flex-col justify-end h-full mb-2">
    <lh-footer></lh-footer>
    <!-- /Footer -->
    <sp-footer></sp-footer>
  </div>
</div>
